import { http, HttpResponse } from 'msw'

import { getResponseObject } from '@webapp/tests/getResponseObject'
import { CardApiModelStub } from '../api-models/stubs/CardApiModel.stub'

export const mockGetMyCardsSuccess = (
  cardStubs = CardApiModelStub.buildList(2)
) => {
  return http.get(
    `/api/v3/pay/cards/`,
    () => {
      return HttpResponse.json(getResponseObject(cardStubs), { status: 200 })
    },
    { once: true }
  )
}
